import { STATUSES } from '@/constants/common/message.constants'

/**
 * 配送ステータス（配送進捗の10段階 + 軸跨ぎ2値。手動変更可能）
 *
 * swagger再生成後、aspida型から導出可能になる。
 * 再生成前は手動定義で全ステータス値をカバーする。
 *
 * CANCELLED / REVOKED は時系列軸を外れた軸跨ぎ値。業務上の意味が異なる:
 * - CANCELLED（キャンセル）= 配車したが結局運行しなかった
 * - REVOKED（取消）= 依頼したが、その依頼を取り消した（そもそも運ばない）
 */
export type ShipmentDeliveryStatusType =
  | 'UNORDERED'
  | 'BEFORE_DISPATCH'
  | 'DISPATCHING'
  | 'DISPATCH_CONFIRMED'
  | 'TRUCK_NOTIFIED'
  | 'DELIVERY_INSTRUCTED'
  | 'SAME_DAY_GUIDED'
  | 'LOADING_COMPLETED'
  | 'UNLOADING_COMPLETED'
  | 'DELIVERY_COMPLETED'
  | 'CANCELLED'
  | 'REVOKED'

export const SHIPMENT_DELIVERY_STATUS_TYPE = {
  /** 未受注 */
  UNORDERED: 'UNORDERED',
  /** 受注済 */
  BEFORE_DISPATCH: 'BEFORE_DISPATCH',
  /** 配車中 */
  DISPATCHING: 'DISPATCHING',
  /** 配車確定 */
  DISPATCH_CONFIRMED: 'DISPATCH_CONFIRMED',
  /** 車番連絡済 */
  TRUCK_NOTIFIED: 'TRUCK_NOTIFIED',
  /** 配送指示済 */
  DELIVERY_INSTRUCTED: 'DELIVERY_INSTRUCTED',
  /** 当日誘導済 */
  SAME_DAY_GUIDED: 'SAME_DAY_GUIDED',
  /** 積込完了 */
  LOADING_COMPLETED: 'LOADING_COMPLETED',
  /** 降ろし完了 */
  UNLOADING_COMPLETED: 'UNLOADING_COMPLETED',
  /** 配送完了 */
  DELIVERY_COMPLETED: 'DELIVERY_COMPLETED',
  /** キャンセル */
  CANCELLED: 'CANCELLED',
  /** 取消 */
  REVOKED: 'REVOKED'
} as const satisfies Record<
  ShipmentDeliveryStatusType,
  ShipmentDeliveryStatusType
>

export const SHIPMENT_DELIVERY_STATUS_TYPE_LABEL = {
  [SHIPMENT_DELIVERY_STATUS_TYPE.UNORDERED]: STATUSES.UNORDERED,
  [SHIPMENT_DELIVERY_STATUS_TYPE.BEFORE_DISPATCH]: STATUSES.BEFORE_DISPATCH,
  [SHIPMENT_DELIVERY_STATUS_TYPE.DISPATCHING]: STATUSES.DISPATCHING,
  [SHIPMENT_DELIVERY_STATUS_TYPE.DISPATCH_CONFIRMED]:
    STATUSES.DISPATCH_CONFIRMED,
  [SHIPMENT_DELIVERY_STATUS_TYPE.TRUCK_NOTIFIED]: STATUSES.TRUCK_NOTIFIED,
  [SHIPMENT_DELIVERY_STATUS_TYPE.DELIVERY_INSTRUCTED]:
    STATUSES.DELIVERY_INSTRUCTED,
  [SHIPMENT_DELIVERY_STATUS_TYPE.SAME_DAY_GUIDED]: STATUSES.SAME_DAY_GUIDED,
  [SHIPMENT_DELIVERY_STATUS_TYPE.LOADING_COMPLETED]: STATUSES.LOADING_COMPLETED,
  [SHIPMENT_DELIVERY_STATUS_TYPE.UNLOADING_COMPLETED]:
    STATUSES.UNLOADING_COMPLETED,
  [SHIPMENT_DELIVERY_STATUS_TYPE.DELIVERY_COMPLETED]:
    STATUSES.DELIVERY_COMPLETED,
  [SHIPMENT_DELIVERY_STATUS_TYPE.CANCELLED]: STATUSES.CANCELLED,
  [SHIPMENT_DELIVERY_STATUS_TYPE.REVOKED]: STATUSES.REVOKED
} as const satisfies Record<ShipmentDeliveryStatusType, string>
